if (!customElements.get('trust-indicators-slider')) {
  class TrustIndicatorsSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      const pagination = this.querySelector('.section-trust-indicators__pagination');

      this.slider = new Swiper(this, {
        slidesPerView: swiperOptions.slidesPerViewMobile || 1.1,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        pagination: pagination ? { el: pagination, clickable: true } : false,
        breakpoints: {
          750: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: swiperOptions.slidesPerViewTablet || 3,
            loop: false,
          },
          990: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: swiperOptions.slidesPerViewDesktop || swiperOptions.slidesPerViewTablet || 3,
          },
          991: {
            enabled: false,
          }
        }
      });
    }
  }

  customElements.define('trust-indicators-slider', TrustIndicatorsSlider);
}
